import { MantrailingForm, MantrailingFormHandle } from "./MantrailingForm";
import { HikingForm, HikingFormHandle } from "./HikingForm";
import { DetectionForm, DetectionFormHandle } from "./DetectionForm";
import { TrailCategory } from "../../types/trail";
import { ForwardRefExoticComponent, RefAttributes } from "react";

// Union type for all form handles
export type ActivityFormHandle =
  | MantrailingFormHandle
  | HikingFormHandle
  | DetectionFormHandle;

// Props type for activity forms (minimal props now)
export interface ActivityFormProps {
  user: any;
  dogsPlaceholder?: any[];
  location: string;
  setLocation: (location: string) => void;
  onDistanceChange: (distance: number) => void;
  onDurationChange: (duration: number) => void;
  onLocationCoordinateChange: (coords: [number, number]) => void;
}

// Registry mapping category to form component with proper typing
export const activityFormRegistry: Record<
  TrailCategory,
  ForwardRefExoticComponent<
    ActivityFormProps & RefAttributes<ActivityFormHandle>
  >
> = {
  mantrailing: MantrailingForm as any,
  hiking: HikingForm as any,
  detection: DetectionForm as any,
};
